import { ApiImage } from 'utilities/types'
import { api } from './index'

type card_image_type = 'default' | 'custom'

export type GiftCardProvider = {
  id: number
  name: string
  card_image_type: card_image_type
  card_background_color: string | undefined
  card_background_image: ApiImage | null
  external_link_enabled: boolean
  external_link_image: ApiImage | null
  external_link_url: string | null
}

export type GetGiftCardProvidersResponse = {
  gift_card_providers: GiftCardProvider[]
}

type FileUploadsPayload = Partial<
  Record<'external_link_image' | 'card_background_image', FileUploadPayload>
>
type FileUploadPayload =
  | {
      file_upload_id: number
    }
  | {
      destroy: boolean
    }

export type UpdateGiftCardProviderPayload = {
  id: number
  gift_card_provider: {
    card_image_type: card_image_type
    external_link_enabled: boolean
    card_background_color?: string
    external_link_url?: string
    file_uploads: FileUploadsPayload
  }
}

export type UpdateGiftCardProviderResponse = {
  gift_card_provider: GiftCardProvider
}

export const giftCardProvidersApi = api.injectEndpoints({
  endpoints: builder => ({
    getGiftCardProviders: builder.query<GetGiftCardProvidersResponse, void>({
      query: () => ({
        url: 'gift_card_providers',
        method: 'GET',
      }),
      providesTags: ['GiftCardProvider'],
    }),
    updateGiftCardProvider: builder.mutation<
      UpdateGiftCardProviderResponse,
      UpdateGiftCardProviderPayload
    >({
      query: ({ id, gift_card_provider }) => ({
        url: `gift_card_providers/${id}`,
        method: 'PATCH',
        body: {
          gift_card_provider,
        },
      }),
      invalidatesTags: ['GiftCardProvider'],
    }),
  }),
})
